<script>
  import { fly } from "svelte/transition";
  import Quote from "../components/quote.svelte";
  import { pagingStore } from "../stores/paging.js";
  pagingStore.showPrev(true);
  pagingStore.showNext(true);

  import { laraStore } from "../stores/lara.js";
  laraStore.followMouse(false);
  laraStore.setCoords({ x: 500, y: 500 });

  import { stylesBackground, stylesColor } from "../stores/styles.js";
  stylesBackground.set("gray");
  stylesColor.set("black");
</script>

<div class="page">
  <Quote title="Validarien">
    "Land in Sicht" - nach 12 Tagen schallten endlich die ersehnten drei Worte durch die Kojen.
  </Quote>
</div>
